import styled from 'styled-components';

export const SiteFooter = styled.footer`
  margin-bottom: 20px;

  p {
    color: #aaa;
    font-size: 0.8em;
    font-style: italic;
  }

`;



// WEBPACK FOOTER //
// ./src/components/Footer.style.js